import { GraphQLClient } from 'graphql-request'

import { getSdk } from '#app/__generated__/sdk.ts'

import { type SupportedLocales } from './i18n.ts'

let client: GraphQLClient | null = null

function getClient() {
  if (client) return getSdk(client)
  client = new GraphQLClient(`${process.env.STRAPI_API_URL}/graphql`, {
    headers: {
      Authorization: `Bearer ${process.env.STRAPI_API_TOKEN}`,
    },
  })
  return getSdk(client)
}

export async function getNavigation(locale: SupportedLocales) {
  const client = getClient()
  try {
    const response = await client.GetNavigation({ locale })
    return response.navigation.data?.attributes
  } catch (error) {
    console.error(error)
  }
}

export async function getPageBySlug(locale: SupportedLocales, slug: string) {
  const client = getClient()
  try {
    const response = await client.GetPageBySlug({ locale, slug })
    return response.pages.data[0]?.attributes
  } catch (error) {
    console.error(error)
  }
}

export async function getVacancyBySlug(locale: SupportedLocales, slug: string) {
  const client = getClient()
  try {
    const response = await client.GetVacancyBySlug({ locale, slug })
    return response.vacancies.data[0]?.attributes
  } catch (error) {
    console.error(error)
  }
}

export async function getAllVacancies(locale: SupportedLocales) {
  const client = getClient()
  try {
    const response = await client.GetVacancies({ locale })
    return response.vacancies.data
  } catch (error) {
    console.error(error)
  }
}

export async function getAllPageSlugs(locale: SupportedLocales) {
  const client = getClient()
  try {
    const response = await client.GetAllPageSlugs({ locale })
    return response.pages.data
  } catch (error) {
    console.error(error)
  }
}
